import { ActivatedRoute } from "@angular/router";

export class BreadCrumb {
  resourceKey: string;
  url: string;
  constructor(resourceKey: string, url: string) {
    this.resourceKey = resourceKey;
    this.url = url;
  }
}

export interface BreadCrumbConfig {
  route: ActivatedRoute,
  path: string,
  url: string,
  breadcrumbs: BreadCrumb[],
  resourceKey?: string
}
